var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1981 16.3302C18.81 16.8908 18.3728 17.4159 17.8918 17.8992C17.4093 18.3846 16.8848 18.8264 16.3244 19.2194L26.4512 29.4025C26.8343 29.7877 27.3433 29.9999 27.8845 29.9999C28.4257 29.9999 28.9347 29.7877 29.3178 29.4025C30.1119 28.6039 30.1119 27.3046 29.3178 26.5061L19.1981 16.3302ZM2.93235 16.6606C4.7642 18.5026 7.19937 19.5171 9.78936 19.5171C12.3793 19.5171 14.8145 18.5026 16.6464 16.6606C20.4312 12.8548 20.4312 6.66227 16.6464 2.85645C14.8145 1.01447 12.3793 0 9.78936 0C7.19943 0 4.76414 1.01447 2.93235 2.85651C-0.852449 6.66227 -0.852449 12.8548 2.93235 16.6606ZM3.76794 9.40695H5.86515L8.18322 4.32552L10.2366 11.4704L12.7223 7.10065L14.4434 9.35975H16.1693V11.1163H13.5734L12.9354 10.2788L9.70065 15.9651L7.8082 9.38001L6.99456 11.1636H3.76794V9.40695ZM1.98252 25.9164L3.564 21.9456L5.19584 22.5955L3.61436 26.5663L1.98252 25.9164ZM11.4405 23.2593L13.176 22.9853L13.7956 26.9094L12.0601 27.1834L11.4405 23.2593ZM21.1952 3.04353L24.9822 1.05598L25.799 2.61229L22.012 4.59984L21.1952 3.04353ZM23.1985 12.4983L23.2916 10.7435L27.2594 10.954L27.1663 12.7088L23.1985 12.4983Z",
    fill: "#02020A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature42);
export default __webpack_public_path__ + "static/media/feature-4-2.7c1a273cd9ac4349d3974a92b9ce2a56.svg";
export { ForwardRef as ReactComponent };